// extracted by mini-css-extract-plugin
module.exports = {"section-wrapper":"banner_section-wrapper__jmRuN","image-wrapper":"banner_image-wrapper__9oLDI","content-wrapper":"banner_content-wrapper__tXpRw"};